// extracted by mini-css-extract-plugin
export default {"containerScroll":"cf20c9g9q","container":"cghq0pabx","videoHolder":"cv9zm0hax"};